import React,{useState,useContext} from 'react';
// useEffect,
import ReactTooltip from 'react-tooltip';
import { Table, Container, Row, Col, Modal, Button } from 'react-bootstrap';
// , FormControl, InputGroup, Dropdown, DropdownButton, SplitButton, Form, FormCheck
// import { Link } from "react-router-dom";

import { apiUrl, searchUrl, myHeaders_Auth_With_Cache_Control } from "Api/Api";
// , owner_perms, user_access_level, org_uuid, user_entity_uuid,
import axios from "axios";

import { local_routes } from 'utils/Routes';

import Select from 'react-select';

import { assembleNickname } from "utils/Helper.js";

import { useAsyncEffect } from "use-async-effect";

import UserContext from 'store/UserContext';

import './style.css';


function PresentationEventManageModal (props) {

  //const [publish_dropdown_option_index, setPublishDropdownOptionIndex] = useState(props.publish_dropdown_option_index);
  //const [entity_access_array, setEntityAccessArray] = useState([]);
  //const [add_user_read_write_option_index, setAddUserReadWriteOptionIndex] = useState(0); // 'Can Edit' will show first
  //const [add_user_text, setAddUserText] = useState('');
  //const [add_user_text_invalid, setAddUserTextInvalid] = useState('');
  //const [add_user_text_valid, setAddUserTextValid] = useState('');
  const [presentation_event_obj, setPresentationEventObj] = useState(null);
  const [message, setMessage] = useState(<React.Fragment></React.Fragment>);
  const [loading, setLoading] = useState(true);
  
  const [submittable_community_pk_option, setSubmittableCommunityPkOption] = useState(null);
  //const [submittable_community_pk_options, setSubmittableCommunityPkOptions] = useState([]);
  
  const [can_edit_community_pk, setCanEditCommunityPk] = useState(true);
  
  const user_context = useContext(UserContext);
  //console.log("PresentationEventManageModal user_info",user_context.user_info);
  //console.log("PresentationEventManageModal",owner_perms);


  async function handlePresentationSubmit (event_obj, grant_edit_flag, unsubmit_flag) {
    console.log("handlePresentationSubmit",event_obj);

    let action_time = Math.floor(new Date().getTime() / 1000);

    let patch_obj = {
      events: [
        {
          entity_uuid: event_obj.entity_uuid,
          xref_data: {
            submitted_time: unsubmit_flag ? -1 : action_time
          }
        }
      ]
    };
    if (grant_edit_flag && event_obj.event_owner_obj && event_obj.event_owner_obj.entity_uuid) {
      patch_obj.users = [
        {
          entity_uuid: event_obj.event_owner_obj.entity_uuid,
          xref_data: {
            entity_owner_integer: 2
          }
        }
      ]
    }
    
    axios.patch(`${apiUrl}${props.entity_info.entity_type}/${props.entity_info.entity_uuid}`,patch_obj);
    
    // also send notification email to event organizer
    let link_base_url = window.location.protocol + '//' + window.location.hostname + '/';
    let event_url = '$link_base_url$'+local_routes.events.slice(1) + '/' + event_obj.friendly_url;
    if (event_obj.status_code !== 1) {
        event_url = '$link_base_url$'+local_routes.events.slice(1);
    }
    let my_pks_url = '$link_base_url$'+local_routes.pklist.slice(1);
    let account_settings_url = '$link_base_url$'+local_routes.accountsettings.slice(1);

    let manage_event_presenters_url = '$link_base_url$'+local_routes.manageevent.slice(1)+'/'+event_obj.entity_uuid+'/presenters';
        
    let grant_edit_clause = '';
    if (grant_edit_flag) {
      grant_edit_clause = ', and you have been granted edit privileges to this presentation';
    }

    let email_template_data = {
        subject: 'Presentation '+props.entity_info.entity_name+' Has Been Submitted to Event '+event_obj.entity_name,
        information: 'PechaKucha.com presentation '+props.entity_info.entity_name+' has been submitted to the event '+event_obj.entity_name+' by '+user_context.user_info.nickname+grant_edit_clause+'.',
        more_information: 'This presentation can be accepted to/rejected from the event <a href=\''+manage_event_presenters_url+'\'>here</a><br/>More information about this event can be found <a href=\''+event_url+'\'>here</a>.<br/>All of your presentation information can be found <a href=\''+my_pks_url+'\'>here</a>.',
        account_settings_url
    }
    
    let email_notification_post_obj = {
        email_template_data,
        user_uuid: event_obj.event_owner_obj.entity_uuid,
        email_template_name: 'ses_email_triggered-presentation_event_notification',
        link_base_url
    }
    
    axios.post(`${apiUrl}users/sendTemplateEmail`, email_notification_post_obj);
    

    // modify state vars to reflect action
    let tmp_presentation_event_obj = {...presentation_event_obj}
    if (!unsubmit_flag) {
      tmp_presentation_event_obj.action_history.push({
        event_uuid: event_obj.entity_uuid,
        event_name: event_obj.entity_name,
        friendly_url: event_obj.status_code === 1 ? event_obj.friendly_url : '',
        label: 'Submitted',
        action_time
      });
      
      if (event_obj.event_type && event_obj.event_type === 'community_pk') {
        tmp_presentation_event_obj.submittable_community_pk_events = tmp_presentation_event_obj.submittable_community_pk_events.filter(item => item.entity_uuid !== event_obj.entity_uuid);        
        setSubmittableCommunityPkOption(null);
      } else {
        tmp_presentation_event_obj.submittable_invited_events = tmp_presentation_event_obj.submittable_invited_events.filter(item => item.entity_uuid !== event_obj.entity_uuid);
      }
      tmp_presentation_event_obj.unsubmittable_events.push(event_obj);
    } else {
      if (event_obj.event_type && event_obj.event_type === 'community_pk') {
        tmp_presentation_event_obj.submittable_community_pk_events.push(event_obj);
      } else {
        tmp_presentation_event_obj.submittable_invited_events.push(event_obj);
      }
      tmp_presentation_event_obj.unsubmittable_events = tmp_presentation_event_obj.unsubmittable_events.filter(item => item.entity_uuid !== event_obj.entity_uuid);
    }
    
    setPresentationEventObj(tmp_presentation_event_obj);
    setMessage(<p>{unsubmit_flag ? 'Unsubmitted' : 'Submitted'}</p>);

    //props.OnChangePublishOption(patch_obj,props.entity_info,props.index);
  }
  
  // on show
  useAsyncEffect(async () => {
    // setup entity owners array
    //console.log("PresentationEventManageModal",props);
    if (!props.show || presentation_event_obj) {
      // we are hiding, or we already have our list
      setMessage(<React.Fragment></React.Fragment>);
      return;
    }
    setLoading(true);

    let presentation_obj = props.entity_info;
    
    let tmp_presentation_event_obj = {
      action_history: [],
      submittable_invited_events: [],
      submittable_community_pk_events: [],
      all_submittable_events: [],
      unsubmittable_events: []
    };
    
    

    // get submittable events
    let presenter_entity_uuid;
    //let possible_community_events = [];
    
    //let possible_community_events = presentation_obj.possible_community_events;
    
    if (presentation_obj.xref_data && presentation_obj.xref_data.presenter_integer) {
      // current user is the presentation presenter
      presenter_entity_uuid = user_context.user_info.entity_uuid;
    } else if (presentation_obj.xref_data && presentation_obj.xref_data.entity_owner_integer) {
      // current user is an owner, but not a presenter. get the presenter.
      let presenter_obj = await fetchPresentationPresenterData(presentation_obj.entity_uuid);
      if (presenter_obj && presenter_obj.entity_uuid) {
        presenter_entity_uuid = presenter_obj.entity_uuid
      } else {
        console.error("ERROR - NO PRESENTER!");
      }
    } else if (presentation_obj.users && presentation_obj.users[0] && presentation_obj.users[0].entity_uuid) {
      // org presentation list; presenter is in the users array
      presenter_entity_uuid = presentation_obj.users[0].entity_uuid;
      //possible_community_events = await fetchSubmitableEvents(presenter_entity_uuid);
    }
    
    let possible_events = await fetchSubmitableEvents(presenter_entity_uuid);

    console.log("PresentationEventManageModal events possible_community_events",presentation_obj.events,possible_events);

    // build history
    if (presentation_obj.events && presentation_obj.events.length > 0) {
      for (let i = 0; i < presentation_obj.events.length; i++) {
  
        if (presentation_obj.events[i].xref_data && presentation_obj.events[i].xref_data.order_integer && presentation_obj.events[i].xref_data.order_integer > 0) {
          // accepted!
          console.log("ACCEPTED",i,presentation_obj.events[i].xref_data.accepted_time,presentation_obj.events[i].start_time);
          tmp_presentation_event_obj.action_history.push({
            event_uuid: presentation_obj.events[i].entity_uuid,
            event_name: presentation_obj.events[i].entity_name,
            friendly_url: presentation_obj.events[i].status_code === 1 ? presentation_obj.events[i].friendly_url : '',
            label: 'Accepted',
            action_time: presentation_obj.events[i].xref_data.accepted_time || presentation_obj.events[i].start_time,
            order_integer: presentation_obj.events[i].xref_data.order_integer
          });
          
          possible_events = possible_events.filter(item => item.entity_uuid !== presentation_obj.events[i].entity_uuid);
          //continue;
        }
        
        if (presentation_obj.events[i].xref_data && presentation_obj.events[i].xref_data.rejected_time) {
          // submitted then rejected
          console.log("REJECTED",i);
          tmp_presentation_event_obj.action_history.push({
            event_uuid: presentation_obj.events[i].entity_uuid,
            event_name: presentation_obj.events[i].entity_name,
            friendly_url: presentation_obj.events[i].status_code === 1 ? presentation_obj.events[i].friendly_url : '',
            label: 'Rejected',
            action_time: presentation_obj.events[i].xref_data.rejected_time
          });
          
          possible_events = possible_events.filter(item => item.entity_uuid !== presentation_obj.events[i].entity_uuid);
          //continue;
        }
  
        if (presentation_obj.events[i].xref_data && presentation_obj.events[i].xref_data.submitted_time) {
          // submitted
          console.log("SUBMITTED",i);
          tmp_presentation_event_obj.action_history.push({
            event_uuid: presentation_obj.events[i].entity_uuid,
            event_name: presentation_obj.events[i].entity_name,
            friendly_url: presentation_obj.events[i].status_code === 1 ? presentation_obj.events[i].friendly_url : '',
            label: 'Submitted',
            action_time: presentation_obj.events[i].xref_data.submitted_time
          });
          tmp_presentation_event_obj.unsubmittable_events.push(presentation_obj.events[i]);
          
          possible_events = possible_events.filter(item => item.entity_uuid !== presentation_obj.events[i].entity_uuid);
          //continue;                   
        }
        
      }
    }

    presentation_obj.possible_events = possible_events;

    // get owner info for submittable events
    if (presentation_obj.possible_events && presentation_obj.possible_events.length > 0) {
      let fetch_event_owner_data_promises = [];
      for (let i = 0; i < presentation_obj.possible_events.length; i++) {
        if (presentation_obj.possible_events[i].entity_uuid) {
          fetch_event_owner_data_promises.push(fetchEventOwnerData(presentation_obj.possible_events[i].entity_uuid));
        } else {
          // dummy
          fetch_event_owner_data_promises.push({});
        }
      }
      let event_owners_array = await Promise.all(fetch_event_owner_data_promises);
     
      for (let i = 0; i < presentation_obj.possible_events.length; i++) {
     
        if (presentation_obj.possible_events[i].entity_uuid) {
     
          tmp_presentation_event_obj.all_submittable_events.push({
            ...presentation_obj.possible_events[i],
            event_owner_obj: event_owners_array[i],
            can_edit_checked: true
          });
        }
      }
    }

    // split possible_community_events into two lists - one for invited, one for community_pk
    tmp_presentation_event_obj.submittable_invited_events = tmp_presentation_event_obj.all_submittable_events.filter(item => ((!item.event_type || item.event_type === 'normal')));
    tmp_presentation_event_obj.submittable_community_pk_events = tmp_presentation_event_obj.all_submittable_events.filter(item => (item.event_type && item.event_type === 'community_pk'));

    // uniquify community events in case there are dupes due to a user already being a presenter for a community pk event
    tmp_presentation_event_obj.submittable_community_pk_events = tmp_presentation_event_obj.submittable_community_pk_events.filter((v,i,a)=>a.findIndex(t=>(t.entity_uuid === v.entity_uuid))===i);

    tmp_presentation_event_obj.action_history = tmp_presentation_event_obj.action_history.sort((a, b) => (a.action_time < b.action_time) ? 1 : -1);
    tmp_presentation_event_obj.submittable_invited_events = tmp_presentation_event_obj.submittable_invited_events.sort((a, b) => (a.start_time < b.start_time) ? 1 : -1);

    console.log("FINAL presentation_event_obj",tmp_presentation_event_obj);

    setPresentationEventObj(tmp_presentation_event_obj);
    setLoading(false);
                    
  }, () => {}, [props.show]);

  function handleCanEditChange (submittable_event_index) {
    let tmp_presentation_event_obj = {...presentation_event_obj};
    tmp_presentation_event_obj.submittable_invited_events[submittable_event_index].can_edit_checked = !tmp_presentation_event_obj.submittable_invited_events[submittable_event_index].can_edit_checked;
    setPresentationEventObj(tmp_presentation_event_obj);
  }
  
  function handleCanEditCommunityPk () {
    setCanEditCommunityPk(!can_edit_community_pk);
  }

  async function fetchSubmitableEvents (presenter_entity_uuid) {
    console.log("PresentationEventManageModal fetching submitable events",presenter_entity_uuid);
    let fetch_submittable_events_promises = [];
    fetch_submittable_events_promises.push(axios.get(`${searchUrl}eventsearch?event_type=community_pk&limit=200`, myHeaders_Auth_With_Cache_Control));
    fetch_submittable_events_promises.push(axios.get(`${apiUrl}users/${presenter_entity_uuid}/events?filter_obj=${encodeURIComponent('{"presenter_integer":{"gte":1}}')}`, myHeaders_Auth_With_Cache_Control));

    let [community_events_response, user_presenter_events_response] = await Promise.all(fetch_submittable_events_promises);
    
    let community_events = community_events_response.data.search_query_results.map((data) => data.entity_info);
    community_events = community_events.sort((a,b) => a.entity_name.localeCompare(b.entity_name));
    //console.log( "community_events",community_events);
    let accept_any_format_events = [];
    let possible_events_by_format = {};
    
    if (user_presenter_events_response && user_presenter_events_response.data && user_presenter_events_response.data.length > 0) {
      for (let invited_event_info of user_presenter_events_response.data) {
          if (!invited_event_info.event_presentation_format) {
              invited_event_info.event_presentation_format = '20x20';
          }
          if (invited_event_info.event_presentation_format === 'any') {
              accept_any_format_events.push(invited_event_info);
          } else {
              if (possible_events_by_format[invited_event_info.event_presentation_format]) {
                  // add to format array
                  possible_events_by_format[invited_event_info.event_presentation_format].push(invited_event_info);
              } else {
                  // create format array
                  possible_events_by_format[invited_event_info.event_presentation_format] = [invited_event_info];
              }
          }
      }
    }
    
    if (community_events.length > 0) {
        for (let community_event_info of community_events) {
            if (community_event_info.event_presentation_format) {
                if (community_event_info.event_presentation_format === 'any') {
                    accept_any_format_events.push(community_event_info);
                } else {
                    if (possible_events_by_format[community_event_info.event_presentation_format]) {
                        // add to format array
                        possible_events_by_format[community_event_info.event_presentation_format].push(community_event_info);
                    } else {
                        // create format array
                        possible_events_by_format[community_event_info.event_presentation_format] = [community_event_info];
                    }
                }
            }
        }
    }
    
    
    
    //console.log( "community_events_by_format",community_events_by_format);
    

    
    let tmp_pk_format = props.entity_info.slide_count+'x'+props.entity_info.slide_length;
    let possible_events = [...accept_any_format_events];
    if (possible_events_by_format[tmp_pk_format]) {
        possible_events = possible_events.concat(possible_events_by_format[tmp_pk_format]);
    }
    //console.log( "possible_events",tmp_pk_format,possible_events);
            
            // now filter out events where we already have at least one presentation accepted
            //possible_community_events = possible_community_events.filter(item => !(item.entity_uuid in already_submitted_events));
            
    //possible_community_events.unshift({entity_name:'Submit to an Event'});
            
            // if user is not the presenter for some reaon, do not allow them to submit
            //if (!props.entity_info.xref_data || !props.entity_info.xref_data.presenter_integer) {
            //    props.entity_info.possible_community_events = [];
            //}
            
            //possible_community_events.unshift({entity_name:'Submit to an Event'});
            //console.log(" tmp_pk_format",tmp_pk_format,possible_community_events);
            //presentation_obj.possible_community_events = possible_community_events;
    
    return possible_events;
  }

  async function fetchPresentationPresenterData (presentation_uuid) {
    console.log("PresentationEventManageModal fetching presentation presenter", presentation_uuid);
    let params = {
      filter_obj: {
        presenter_integer: {
          eq: 1
        }
      }
    }
    let response = await axios.get(`${apiUrl}presentations/${presentation_uuid}/users`, { params, ...myHeaders_Auth_With_Cache_Control });
    
    let presenter_obj = null;
    
    if (response.data && response.data.length > 0) {
      presenter_obj = response.data[0];
    }
    
    return presenter_obj;
  }

  async function fetchEventOwnerData (event_uuid) {
    console.log("PresentationEventManageModal fetching related event owner",event_uuid);
    
    let event_owner_obj = null;
    
    let params = {
      filter_obj: {
        entity_owner_integer: {
          gte: 1
        }
      },
      sort_obj: {
        entity_owner_integer: 'asc'
      }
    }
    
    //let response = await axios.get(`${apiUrl}events/${event_uuid}/users?filter_obj=${encodeURIComponent('{"entity_owner_integer":{"eq":1}}')}`,myHeaders_Auth_With_Cache_Control);
    let response = await axios.get(`${apiUrl}events/${event_uuid}/users`, { params, ...myHeaders_Auth_With_Cache_Control });
    
    if (response.data && response.data.length > 0) {
      event_owner_obj = response.data[0];
      event_owner_obj.nickname = assembleNickname(event_owner_obj);
      if (event_owner_obj.avatar_image_url) {
        let array = event_owner_obj.avatar_image_url.split("/");
        event_owner_obj.adjusted_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_50x50/${array[5]}`;
      }
    }
    
    console.log("PresentationEventManageModal related event owner",event_owner_obj);
    return event_owner_obj;
  };
  
  function renderCommunityPkSubmitDropdown () {
    
    let tmp_options = presentation_event_obj.submittable_community_pk_events.map( (item,index) => (
      {
        label: item.entity_name,
        value: item
      }
    ));

    let contents =  <Select
      //menuPortalTarget={document.querySelector('body')}
      //className='workspace_dropdown_menu'
      //classNamePrefix=''
      value={submittable_community_pk_option}
      onChange={onCommunityPkSubmitChange}
      options={tmp_options}
    />;
   
    return contents; 
  }
  
  function onCommunityPkSubmitChange(selected_option) {
    console.log("onCommunityPkSubmitChange",selected_option);
    setSubmittableCommunityPkOption(selected_option)
  }
  
  return (
    <Modal
      style={{ color: 'black' }}
      show={props.show}
      onHide={props.onHide}
      //{...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.entity_info.entity_name}<br/>
          <span style={{ fontSize: "smaller", color: "darkgray" }}>Related Events</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ReactTooltip />
        {message}
        { !loading ?
        <Container>
          <Row>
            <Col>
              History
            </Col>
          </Row>
          <Row>
            <Col>
              
                <React.Fragment>
                { presentation_event_obj.action_history.length > 0 ?
                  <Table bordered hover size="sm">
                    <thead>
                      <tr>
                        <th>Event</th>
                        <th>Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                    { 
                      presentation_event_obj.action_history.map((item, index) =>
                        <tr key={index}>
                          <td>
                            { item.friendly_url ?
                              <a target="_blank" href={local_routes.events+'/'+item.friendly_url}>{item.event_name}</a>
                            :
                              <span>{item.event_name}</span>
                            }
                          </td>
                          <td style={{ fontSize: "smaller" }}>{new Date(item.action_time * 1000).toLocaleString()}</td>
                          <td>{item.label}</td>
                        </tr>
                      )
                    }
                    </tbody>
                  </Table>
                  :
                  <p>None</p>
                }
                </React.Fragment>
              
            </Col>
          </Row>
          <hr/>
          <Row>
            <Col>
              <p data-tip="These are events that you have been invited to as a Presenter">Pending Event Invitations</p>
            </Col>
          </Row>
          <Row>
            <Col>
              
                <React.Fragment>
                { presentation_event_obj.submittable_invited_events.length > 0 ?
                  <Table bordered hover size="sm">
                    <thead>
                      <tr>
                        <th>Event</th>
                        <th>Date</th>
                        <th style={{ whiteSpace: 'nowrap' }}>Grant Edit</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                    {
                      presentation_event_obj.submittable_invited_events.map((item, index) =>
                        <tr key={index}>
                          <td>{item.entity_name}</td>
                          <td style={{ fontSize: "smaller" }}>{new Date(item.start_time * 1000).toLocaleString()}</td>
                          <td>
                            <div className="React__checkbox">
                            <label className="check-box">
                              <input
                                type="checkbox"
                                className="React__checkbox--input"
                                checked={item.can_edit_checked}
                                onChange={() => handleCanEditChange(index)}
                              />
                              <span style={{ cursor: "pointer" }} className="React__checkbox--span" />
                              { item.event_owner_obj && item.event_owner_obj.avatar_image_url &&
                                <img data-tip={"Event Organizer: "+item.event_owner_obj.nickname} className="img-fluid rounded-circle" width="25px" height="25px" src={item.event_owner_obj.adjusted_image_url} alt="event organizer info" />
                              }
                              <ReactTooltip/>
                            </label>
                            </div>
                          </td>
                          <td>
                            <Button
                              className="modal_button"
                              onClick={() => handlePresentationSubmit(item,true,false)}
                              size="sm"
                            >
                              Submit
                            </Button>
                          </td>

                          
                        </tr>
                      )
                    }
                    </tbody>
                  </Table>
                  :
                  <p>None</p>
                }
                </React.Fragment>
              
            </Col>
          </Row>
          <hr/>
          <Row>
            <Col>
              <p data-tip="These are events that anybody can submit their presentations to">Available Community PK Events</p>
            </Col>
          </Row>

          <Row style={{ marginBottom: "10px" }}>
            <Col xs={6}>
              <React.Fragment>
                { presentation_event_obj.submittable_community_pk_events.length > 0 ?
                  <React.Fragment>
                    {renderCommunityPkSubmitDropdown()}
                  </React.Fragment>
                  :
                  <p>None</p>
                }
              </React.Fragment>
            </Col>
            <Col xs={4}>
              { submittable_community_pk_option &&
               <div className="React__checkbox">
                
                <label className="check-box">
                  Grant Edit&nbsp;
                  <input
                    type="checkbox"
                    className="React__checkbox--input"
                    checked={can_edit_community_pk}
                    onChange={() => handleCanEditCommunityPk()}
                  />
                  <span style={{ cursor: "pointer" }} className="React__checkbox--span" />
                  { submittable_community_pk_option.value.event_owner_obj && submittable_community_pk_option.value.event_owner_obj.avatar_image_url &&
                    <img data-tip={"Event Organizer: "+submittable_community_pk_option.value.event_owner_obj.nickname} className="img-fluid rounded-circle" width="25px" height="25px" src={submittable_community_pk_option.value.event_owner_obj.adjusted_image_url} alt="event organizer info" />
                  }
                  <ReactTooltip/>
                </label>
                </div>
              }
            </Col>
            <Col xs={2}>
              { submittable_community_pk_option &&
              <Button
                className="modal_button"
                onClick={() => handlePresentationSubmit(submittable_community_pk_option.value,true,false)}
                size="sm"
              >
                Submit
              </Button>
              }
            </Col>
          </Row>
        </Container>
        :
          <span><em>Loading...</em></span>
        }
      </Modal.Body>
      {/*
      <Modal.Footer>
        <Button className="modal_button_white" onClick={props.onHide}>Done</Button>
      </Modal.Footer>
      */}
    </Modal>
  );
}

function PresentationEventManageModalButton (props) {
  const [modalShow, setModalShow] = React.useState(false);

  //console.log("ShareAccessModalButton",props);

  let button_icon = '';
  let button_text = 'More Options';
  //if (props.event_entity_name) {
  //  button_text = props.event_entity_name;
  //}
  let button_tooltip = 'Click to see more options';

  return (
    <React.Fragment>
      <Button size="sm" style={{ }} data-tip={button_tooltip} variant="primary" onClick={() => setModalShow(true)}>
        {button_icon}{button_text}
      </Button>

      <PresentationEventManageModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        entity_info={props.entity_info}
        //publish_dropdown_options={props.publish_dropdown_options}
        //publish_dropdown_option_index={props.publish_dropdown_option_index}
        //OnChangePublishOption={props.OnChangePublishOption}
        //index={props.index}
      />
      <ReactTooltip />
    </React.Fragment>
  );
}

export default PresentationEventManageModalButton;